var React = require('react');

function CheckGreenBg (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.8799","cy":"12","r":"12","fill":"#ADEAA6","fillOpacity":"0.5","key":0}),React.createElement("path",{"d":"M9.37354 12.2264L11.5601 14.4L16.3889 9.59998","stroke":"#0A9828","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckGreenBg.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = CheckGreenBg;

CheckGreenBg.default = CheckGreenBg;
